import { FormInstance, Tooltip } from 'antd';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import CustomContext from '../../../context/CustomContext';
import { FamilySubscriptionV2, UserSubscriptionV2 } from '../../../model/v2/EntitiesV2';
import notificationService from '../../../services/NotificationService';
import styles from './SubscriptionComponent.module.scss';

class SubscriptionComponent extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.familySubscriptions !== this.props.familySubscriptions ||
            prevProps.userSubscriptions !== this.props.userSubscriptions
        ) {
            this.init();
        }
    }

    /** METHODS **/

    init = async () => {
        const { familyId, userId, familySubscriptions, userSubscriptions } = this.props;

        try {
            const familySubscription = familySubscriptions.find((fs) => fs.familyId === familyId);
            const userSubscription = userSubscriptions.find((us) => us.userId === userId);
            if (familySubscription?.subscriptionExpired && userSubscription?.subscriptionExpired) {
                if (familySubscription.subscriptionExpired.isAfter(userSubscription.subscriptionExpired)) {
                    this.setState({ familySubscription, userSubscription: undefined });
                } else {
                    this.setState({ userSubscription, familySubscription: undefined });
                }
            } else if (familySubscription?.subscriptionExpired) {
                this.setState({ familySubscription, userSubscription: undefined });
            } else if (userSubscription?.subscriptionExpired) {
                this.setState({ userSubscription, familySubscription: undefined });
            } else {
                this.setState({ familySubscription: undefined, userSubscription: undefined });
            }
        } catch (error: any) {
            notificationService.displayError(error, this.props.intl);
        }
    };

    /*** COMPONENTS ***/

    render() {
        const { familySubscription, userSubscription } = this.state;

        if (familySubscription && familySubscription.subscriptionExpired && familySubscription.valid) {
            return (
                <span>
                    <FormattedDate value={familySubscription.subscriptionExpired as any} dateStyle="medium" />
                </span>
            );
        } else if (familySubscription && familySubscription.subscriptionExpired) {
            return (
                <Tooltip title={<FormattedMessage id="subscription.expired.tooltip" />}>
                    <span className={familySubscription.valid ? '' : styles.expired}>
                        <FormattedDate value={familySubscription.subscriptionExpired as any} dateStyle="medium" />
                    </span>
                </Tooltip>
            );
        } else if (userSubscription && userSubscription.subscriptionExpired && userSubscription.valid) {
            return (
                <span>
                    <FormattedDate value={userSubscription.subscriptionExpired as any} dateStyle="medium" />
                </span>
            );
        } else if (userSubscription && userSubscription.subscriptionExpired) {
            return (
                <Tooltip title={<FormattedMessage id="subscription.expired.tooltip" />}>
                    <span className={userSubscription.valid ? '' : styles.expired}>
                        <FormattedDate value={userSubscription.subscriptionExpired as any} dateStyle="medium" />
                    </span>
                </Tooltip>
            );
        } else {
            return <></>;
        }
    }
}
export default injectIntl(SubscriptionComponent);

interface Props extends WrappedComponentProps {
    familyId: number | undefined;
    userId: string | undefined;
    familySubscriptions: FamilySubscriptionV2[];
    userSubscriptions: UserSubscriptionV2[];
}
interface State {
    familySubscription?: FamilySubscriptionV2;
    userSubscription?: UserSubscriptionV2;
}
